module.exports = __webpack_public_path__ + "static/media/Prithika.47c2a5ef.png";